import cssUtil from 'gw-portals-util-js/CssUtil';
import summaryTemplate from 'text!./Summary.html';
import summaryStyles from './Summary-hashed.scss';
import listTemplate from 'text!./List.html';
import listStyles from './List-hashed.scss';
import editTemplate from 'text!./Edit.html';
import editStyles from './Edit-hashed.scss';

var hashedSummaryTemplate = cssUtil.hashTemplate(summaryTemplate, summaryStyles);

var hashedListTemplate = cssUtil.hashTemplate(listTemplate, listStyles);

var hashedEditTemplate = cssUtil.hashTemplate(editTemplate, editStyles);

export default (function (listScheduledItemDirective, editScheduledItemDirective) {
    return ['ModalService', '$filter', '$timeout', function (ModalService, $filter, $timeout) {
        return {
            restrict: 'E',
            template: hashedSummaryTemplate,
            scope: {
                schedule: '&',
                loading: '='
            },
            link: function link($scope) {
                // This directive assumes that even though the schedule on the scope may change due to updates,
                // it is till de-facto same schedule.


                // Loading affects some of the behaviours.
                // Since loading flag is optional and loading might never happen,
                // this utility will handle calling a callback when there is and when there isn't any loading.
                // The expectation here, that if loading flag is working, it's going to change to 'true' and then back to 'false'
                var unwatches = new Map();
                var unwatch = function unwatch(callback) {
                    if (unwatches.has(callback)) {
                        unwatches.get(callback)();
                        unwatches.delete(callback);
                    }
                };
                var whenDoneLoading = function whenDoneLoading(callback) {
                    unwatch(callback);

                    var timeout = void 0;
                    unwatches.set(callback, $scope.$watch('loading', function (loading) {
                        if (typeof loading === 'undefined') {
                            return; // Don't handle a case when loading is undefined
                        }

                        if (loading && timeout) {
                            // We're loading, no need for the timeout
                            $timeout.cancel(timeout);
                        } else if (!loading) {
                            // Now we're done loading and can show a notification
                            unwatch(callback);
                            callback();
                        }
                    }));

                    timeout = $timeout(function () {
                        // When 'loading' flag isn't supplied fallback to showing trigger
                        unwatch(callback);
                        callback();
                    }, 100);
                };
                // Done with 'whenDoneLoading'


                $scope.init = function () {
                    var notification = {
                        text: '',
                        trigger: angular.noop
                    };

                    var notify = function notify(text) {
                        notification.text = text;
                        whenDoneLoading(notification.trigger);
                    };

                    var listModal = void 0;
                    var listScope = void 0;
                    var closeList = function closeList() {
                        listModal.close();
                        listScope.$destroy();
                    };

                    var edit = function edit(scheduledItem, itemIndex) {
                        var isNew = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                        scheduledItem.draft();
                        var editScope = $scope.$new(true);
                        var editModal = void 0;
                        var closeEdit = function closeEdit() {
                            editModal.close();
                            editScope.$destroy();
                        };

                        angular.extend(editScope, {
                            editScheduledItemDirective: editScheduledItemDirective,
                            onBeforeCommit: function onBeforeCommit(cb) {
                                editScope._onBeforeCommit = cb;
                            },

                            isNew: isNew,
                            schedule: $scope.schedule,
                            scheduledItem: scheduledItem,
                            cancel: function cancel() {
                                scheduledItem.undo();
                                closeEdit();

                                if ($scope.schedule().getScheduledItems().length === 0) {
                                    closeList();
                                }
                            },

                            shouldShowErrors: false,
                            save: function save() {
                                var beforeCommitValid = typeof editScope._onBeforeCommit === 'function' ? editScope._onBeforeCommit() : true;
                                if (!scheduledItem.isValid() || !beforeCommitValid) {
                                    this.shouldShowErrors = true;
                                } else {
                                    listScope.focusedIndex = itemIndex;
                                    whenDoneLoading(function () {
                                        var list = $('.js-gw-mobile-scheduled-items-list');
                                        var focused = $('.js-gw-mobile-scheduled-items-focused');

                                        // Position of focused element within scrollable list
                                        // is it's position currently relative to visible part of the list + list.scrollTop()
                                        list.scrollTop(focused.offset().top + (list.scrollTop() - list.offset().top));
                                    });

                                    scheduledItem.commit();
                                    if (isNew) {
                                        $scope.schedule().add(scheduledItem);
                                    }

                                    closeEdit();

                                    notify(isNew ? 'policycommon.directives.schedules.table.Item added' : 'policycommon.directives.schedules.table.Item saved');
                                }
                            }
                        });

                        editModal = ModalService.showFullScreenPopup(hashedEditTemplate, {}, {
                            scope: editScope,
                            windowClass: editStyles.edit,
                            animationType: 'left-right'
                        });
                    };
                    var add = function add() {
                        // Focusing new item works under the assumption that it would be added as last item of the list
                        edit($scope.schedule().createNewItem(), $scope.schedule().getScheduledItems().length, true);
                    };

                    listScope = $scope.$new();
                    angular.extend(listScope, {
                        listScheduledItemDirective: listScheduledItemDirective,

                        add: add,
                        edit: edit,
                        exit: closeList,

                        'delete': function _delete(scheduledItem) {
                            var translate = $filter('translate');
                            ModalService.showWarning(translate('policycommon.directives.schedules.table.Delete item'), translate('policycommon.directives.schedules.table.Are you sure you want to remove this item?'), null, translate('policycommon.directives.schedules.table.Delete')).result.then(function () {
                                $scope.schedule().remove(scheduledItem);
                                notify('policycommon.directives.schedules.table.Item deleted');
                            });
                        },
                        notification: notification
                    });

                    listModal = ModalService.showFullScreenPopup(hashedListTemplate, {}, {
                        scope: listScope,
                        windowClass: listStyles.list,
                        animationType: 'left-right'
                    });

                    if ($scope.schedule().getScheduledItems().length === 0) {
                        add();
                    }
                };
            }
        };
    }];
});


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/MobileViewGenerator/MobileViewGenerator.js
// module id = 269
// module chunks = 0